function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//
import MuiChip from "@mui/material/Chip";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
const Chip = ({
  label,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(MuiChip, _extends({}, rest, {
    label: t(label)
  }));
};
Chip.propTypes = {
  label: PropTypes.string
};
export default Chip;